import { registerIcon } from "@ui5/webcomponents-base/dist/asset-registries/Icons.js";

const name = "navigation-down-arrow";
const pathData = "M360.5 172q11-9 22-9 13 0 22 9 9 10 9 22 0 11-9 22l-124 124q-9 9-22 9-11 0-22-9l-124-124q-9-11-9-22 0-12 9-22 11-9 22-9 13 0 22 9l102 103z";
const ltr = false;
const accData = null;
const collection = "SAP-icons-v5";
const packageName = "@ui5/webcomponents-icons";

registerIcon(name, { pathData, ltr, collection, packageName });

export default "SAP-icons-v5/navigation-down-arrow";
export { pathData, ltr, accData };